import React, { useEffect, useRef, useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { RiLogoutCircleLine } from "react-icons/ri";
import { MdLeaderboard, MdChecklist } from "react-icons/md";
import { BsHourglassTop } from "react-icons/bs";
import { AiOutlineOrderedList } from "react-icons/ai";
import { ToastContainer } from "react-toastify";
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import '../Component/RNavBar.css'
import Util from "./Service/util";
import Service from "./Service/http";
import Alert from 'react-bootstrap/Alert';
import { Link } from "react-router-dom";
import { FaLaptopCode } from 'react-icons/fa'
import { IS_CRAWLER_APPROVED_KEY } from "../constants";

function RNavbar() {
  const util = new Util();
  let [loggedIn, SetLoggedIn] = useState(false);
  let [isAdmin, SetIsAdmin] = useState(false);
  let [contestMode,setContestMode]=useState(false);
  let [role, SetRole] = useState("student");
  let [userDetail, SetUserDetail] = useState(null);
  let [ batches, SetBatches ] = useState([]);
  let [filteredBatches,setfilteredBatches]  = useState([])
  let [searchBatch,SetSearchBatch] = useState("")
  let [show, Setshow] = useState(false);
  let [user, SetUser] = useState({});
  const[crawlerApproved, setCrawlerApproved] = useState(false)

  let service = new Service();
  const inputRef = useRef(null);

  useEffect(() => {
    let isLogin = util.loggedIn();
    SetRole(util.getRole());
    SetIsAdmin(util.isAdmin());
    SetUserDetail(util.getUserDetails());
    SetLoggedIn(isLogin);
    if (!isLogin && window.location.pathname !== "/login") {
      console.log(window.location.pathname);
      window.location.replace("/login");
    }
    if (isLogin) {
      const user = util.getUserDetails();
      SetUser(user);
      const date = new Date().toDateString();
      const lastLogin = localStorage.getItem(user.email + 'lastLogin');
      if(user.role === "student" && (lastLogin == null || lastLogin !== date)){
        localStorage.setItem(user.email + 'lastLogin', date);
        const handlesStatus = localStorage.getItem(user.email + 'handlesStatus');
        if(handlesStatus == null || handlesStatus == "false"){
          service.get('api/user/handles/status')
          .then((res) => {
            if(res.data === false){
              Setshow(true);
            }
          localStorage.setItem(user.email + 'handlesStatus', res.data);
        })
          .catch((err) => {console.log(err);});
        }
      }
      // get all teh batches of the user
      service.get("api/batches").then(json => {
        SetBatches(json.batches)
        setfilteredBatches(json.batches)
      })
      .catch((err) =>{
        console.log(err);
      })

      let id; // let it be undefined for the current user
      if(!localStorage.getItem(IS_CRAWLER_APPROVED_KEY)) {
        service.get("api/profile/coding/"+id).then(
        response =>{ 
          setCrawlerApproved(response.is_crawling_approved);
          localStorage.setItem(IS_CRAWLER_APPROVED_KEY, response.is_crawling_approved);
        }
      ).catch((error) => {
        console.log(error)
      });
    } else setCrawlerApproved(localStorage.getItem(IS_CRAWLER_APPROVED_KEY) == "true");
      // Trying to find contestMode in localStorage first if not found making an api call to backend to get contestMode and storing it
      if (localStorage.getItem('contestMode') == null) {
        service.get('api/contestMode').then((json) => {
          setContestMode(json.REACT_APP_CONTEST_MODE == 'true')
          localStorage.setItem('contestMode', json.REACT_APP_CONTEST_MODE)
        }
        ).catch((err) => { console.log(err) })
      } else {
        setContestMode(localStorage.getItem('contestMode') == 'true')
      }
    }
  }, []);

  return (
    <div>
      <ToastContainer />

      {/* <div className=" bg-info text-start px-3 text-light">
        @BeingZero Platform
      </div> */}

      <nav className="navbar navbar-expand-lg navbar-dark bg-primary p-0">
        <div className="container-fluid">
          <a className="navbar-brand">Being Zero</a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarColor01"
            aria-controls="navbarColor01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarColor01">
            <ul className="navbar-nav me-auto">
              {loggedIn && contestMode? (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tooltip"
                    title="Problem Set"
                    to="/problem/list"
                  >
                    <AiOutlineOrderedList size={20} />
                  </Link>
                </li>
              ) : null}
              {loggedIn ? (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tooltip"
                    title="CP Leaderboard"
                    to="/"
                  >
                    <MdLeaderboard size={20} />
                  </Link>
                </li>
              ) : null}
              {loggedIn ? (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tooltip"
                    title="Criteria"
                    to="/criteria"
                  >
                    <BsHourglassTop size={18} />
                  </Link>
                </li>
              ) : null}
              {loggedIn && contestMode? (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tooltip"
                    title="All Submissions"
                    to="/allSubmissions"
                  >
                    <MdChecklist size={25} />
                  </Link>
                </li>
              ) : null}

              {loggedIn &&
              (role === "mentor") ? (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tooltip"
                    title="Mentor Options"
                    to="/mentor"
                  >
                   <ManageAccountsIcon></ManageAccountsIcon>
                  </Link>
                </li>
              ) : null}

              {(loggedIn && (crawlerApproved || isAdmin)) &&
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tooltip"
                    title="Problem Set"
                    to="/problemset"
                  >
                   <FaLaptopCode size={21}/>
                  </Link>
                </li>
              }
              {loggedIn &&
              (role === "admin") ? (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tooltip"
                    title="Admin Options"
                    to="/admin"
                  >
                   <EngineeringRoundedIcon></EngineeringRoundedIcon>
                  </Link>
                </li>
              ) : null}
              {loggedIn && batches.length > 0 ? (
                <li className="nav-item dropdown">
                  {
                    <button
                      className="nav-link dropdown-toggle "
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                      onClick={(e)=> {inputRef.current.focus()}}
                      style={{background: 'transparent', border: 0}}
                    >
                    Select Batch
                  </button>}
                  <div className="dropdown-menu scrollable-menu" data-bs-popper="static">
                    <input 
                      value={searchBatch}
                      ref={inputRef}
                      style={{outline: 'none'}}
                      onChange={(e)=>{
                        SetSearchBatch(e.target.value)
                        setfilteredBatches(
                          batches.filter((batch)=>{
                            let lbatch=batch.toLowerCase();
                            let srch = e.target.value.toLocaleLowerCase()
                            if(lbatch.includes(srch)||e.target.value===""){
                              return batch
                            }
                          })
                        )
                      } 
                    } type="text" className="dropdown-item" placeholder="Search Batch"></input>
                    <li><hr className="dropdown-divider"/></li>
                    {filteredBatches?.map((batchName) => {
                      return (
                        <Link
                          className="dropdown-item"
                          to={`/batch/${batchName}`}
                        >
                          {batchName}
                        </Link>
                      );
                    })}
                  </div>
                </li>
              ) : null}
            </ul>

            <ul className="navbar-nav  ">
              {loggedIn ? (
                <li className="nav-item">
                  <Link
                    className="nav-link p-0 m-0"
                    to={`/profile/${user?._id}`}
                    data-bs-toggle="tooltip"
                    title="Profile"
                  >
                    <img
                      className="avatar"
                      src={
                        userDetail.avatar ||
                        "https://www.w3schools.com/w3images/avatar5.png"
                      }
                      alt="Avatar"
                    />
                  </Link>
                </li>
              ) : null}
              {!loggedIn ? (
                <li className="nav-item">
                  <a className="nav-link" href="/login">
                    <FcGoogle className="p-0 m-0" size={21} /> Login
                  </a>
                </li>
              ) : (
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="tooltip"
                    title="Logout"
                    onClick={() => {
                      util.logout();
                    }}
                    href="/login"
                  >
                    <RiLogoutCircleLine size={25} />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
      {show ?
      <div style={{  display : "flex", justifyContent : "center", textAlign: "center", border : 0, margin: "1%"}}>
          <Alert style={{ textAlign: "center"  ,width : "60%",paddingBottom : 1, margin : 0 , backgroundColor : "#FFF3CD", borderColor : "#FFECB5" }} variant="warning" closeVariant= "white" onClose={() => Setshow(false)} dismissible>
          <Alert.Heading style = {{color : "black" }}> Hey {user.name}, Please fill/update yours handles in <Link style={{ textDecoration : "underline"}} to="coding/profile" onClick={() => {
            Setshow(false);
          }}>coding profile</Link> page.</Alert.Heading>
         </Alert>
      </div>
        : null
      }
    </div>
  );
}

export default RNavbar;
